var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-cycle"},[_c('Card',{staticClass:"print-cycle__card mb-3",attrs:{"data-testid":"print_relate","title":_vm.relateTitle}},[_c('template',{slot:"content"},[_c('EvidenceSection',{attrs:{"fontSize":"11","imageTestId":"relate_photo","imageHeight":"200","mediaObject":_vm.relatePhoto,"questions":[
          {
            text: _vm.problemQuestion,
            answer: _vm.problemAnswer,
            tid: 'problem_question',
          },
          {
            text: _vm.ideaQuestion,
            answer: _vm.ideaAnswer,
            tid: 'idea_question',
          },
          {
            text: _vm.expectedResultQuestion,
            answer: _vm.expectedResultAnswer,
            tid: 'expected_question',
          },
        ]}})],1)],2),_c('Card',{staticClass:"print-cycle__card mb-3",attrs:{"data-testid":"print_experiment","title":_vm.experimentTitle}},[_c('template',{slot:"content"},[_c('EvidenceSection',{attrs:{"fontSize":"11","imageTestId":"experiment_photo","mediaObject":_vm.experimentPhoto,"questions":[
          {
            text: _vm.experimentResultQuestion,
            answer: _vm.experimentResultAnswer,
            tid: 'experiment_question',
          },
        ]}})],1)],2),_c('Card',{staticClass:"print-cycle__card",attrs:{"data-testid":"print_expand","title":_vm.expandTitle}},[_c('template',{slot:"content"},[_c('EvidenceSection',{attrs:{"fontSize":"11","imageTestId":"expand_photo","mediaObject":_vm.expandPhoto,"questions":[
          {
            text: _vm.expandQuestion,
            answer: _vm.expandAnswer,
            tid: 'expand_question',
          },
        ]}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }